import { Exception } from "../core/Exception.js";
export class MovedTemporarily extends Exception {
    static STATUS = 302;
    name = "MOVED_TEMPORARILY";
    constructor(message, origin) {
        super(MovedTemporarily.STATUS, message, origin);
    }
}
//# sourceMappingURL=MovedTemporarily.js.map